import invisalignLogo from '../assets/invisalign-logo.png';
import sparkLogo from '../assets/spark-logo.png';
import dmIcon from '../assets/dm.svg';

export type CaseLinksManufacturer = 'spark' | 'invisalign';

export interface CaseLinksLogo {
    logo: string;
    name: string;
}

export const CASE_LINKS_BRAND: Readonly<Record<CaseLinksManufacturer, CaseLinksLogo>> = {
    spark: { logo: sparkLogo, name: 'Spark' },
    invisalign: { logo: invisalignLogo, name: 'Invisalign' }
};

export const DM_LOGO: CaseLinksLogo = { logo: dmIcon, name: 'Dental Monitoring' };
